export enum ColorScheme {
  default = 'System',
  dark = 'dark',
  light = 'light',
}